import {
  NEWS_RESEARCH_SETTINGS_STARTED,
  UPDATE_NEWS_RESEARCH_SETTINGS_STARTED,
  UPDATE_NEWS_RESEARCH_SETTINGS,
  NEWS_RESEARCH_SETTINGS_FAILURE,
  NEWS_RESEARCH_RESULT_CLEAR_DATA,
  NEWS_RESEARCH_RESULT_STARTED,
  NEWS_RESEARCH_RESULT_UPDATE,
  NEWS_RESEARCH_RESULT_SUCCESS,
  NEWS_RESEARCH_RESULT_FAILURE,
  UPDATE_NEWS_FILTER,
} from "../constants/newsResearch.constant";

const initialState = {
  settings: {
    updating: false,
    loading: true,
    results: { isAll: false, categories: [] },
    filter: { keyword: "", fromDate: "", toDate: "" },
    error: null,
  },
  data: {
    updating: false,
    loading: true,
    totalResult: 0,
    results: [],
    error: null,
  },
};
export default function downloadFilesReducer(state = initialState, action) {
  switch (action.type) {
    case NEWS_RESEARCH_SETTINGS_STARTED:
      return {
        ...state,
        settings: {
          ...state.settings,
          loading: true,
        },
      };
    case UPDATE_NEWS_RESEARCH_SETTINGS_STARTED:
      return {
        ...state,
        settings: {
          ...state.settings,
          updating: true,
        },
      };
    case UPDATE_NEWS_RESEARCH_SETTINGS:
      return {
        ...state,
        settings: {
          ...state.settings,
          loading: false,
          results: action.payload,
        },
      };
    case NEWS_RESEARCH_SETTINGS_FAILURE:
      return {
        ...state,
        settings: {
          ...state.settings,
          updating: false,
          ...action.payload,
        },
      };
    case NEWS_RESEARCH_RESULT_CLEAR_DATA:
      return {
        ...state,
        data: {
          ...action.payload,
        },
      };
    case NEWS_RESEARCH_RESULT_STARTED:
      return {
        ...state,
        data: {
          ...state.data,
          loading: true,
        },
      };
    case NEWS_RESEARCH_RESULT_UPDATE:
      return {
        ...state,
        data: {
          ...state.data,
          loading: false,
          updating: true,
        },
      };
    case NEWS_RESEARCH_RESULT_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          loading: false,
          updating: false,
          ...action.payload,
        },
      };
    case NEWS_RESEARCH_RESULT_FAILURE:
      return {
        ...state,
        data: {
          ...state.data,
          updating: false,
          loading: false,
          ...action.payload,
        },
      };
    case UPDATE_NEWS_FILTER:
      return {
        ...state,
        settings: {
          ...state.settings,
          filter: {
            ...state.settings.filter,
            ...action.payload,
          },
        },
      };
    default:
      return state;
  }
}
